import * as types from '../types'

/**
 * 用户信息
 * base: 用户基本信息
 * favorList: 用户喜欢商品列表
 * addressList: 地址列表
 * curAddressId: 当前编辑地址id
 * couponList: 优惠券列表
 * usualList: 我常购的
 * recharge: 余额相关
 * @type {Object}
 */
const state = {
    base:           {},
    favorList:      [],
    packageList:    [],
    addressList:    [],
    recharge: {
        cards:      [
            {
                id: 1,
                name: '100元充值卡',
                expire_time: '2018-6-20'
            },
            {
                id: 2,
                name: '200元充值卡',
                expire_time: '2019-6-21'
            }
        ],
        list:       []
    },
    curAddressId:   1,
    couponList:     [],
    usualList:      []
}

const getters = {

}

const mutations = {
    [types.CHANGE_CUR_ADDRESS] (state, curId) {
        state.curAddressId = curId
    },

    [types.CHANGE_ADDRESS_LIST] (state, list) {
        state.addressList = list
    },

    [types.AJAX_CHANGE_ADDRESS] (state, list) {
        state.addressList = state.addressList.concat(list)
    },

    [types.AJAX_DEL_ADDRESS] (state, id) {
        for(let i in state.addressList) {
            if (state.addressList[i]['id'] == id) {
                state.addressList.splice(i , 1)
            }
        }
    },

    [types.CHANGE_MEMBER_INFO] (state, data) {
        state.base = data
    },

    [types.CHANGE_COUPON_LIST] (state, list) {
        state.couponList = list
    },

    [types.AJAX_CHANGE_COUPON] (state, list) {
        state.couponList = state.couponList.concat(list)
    },

    [types.CHANGE_RECHARGE_LIST] (state, list) {
        state.recharge.list = list
    },

    [types.AJAX_UPDATE_RECHARGE] (state, list) {
        state.recharge.list = state.recharge.list.concat(list)
    },

    [types.CHANGE_MY_FAVOR] (state, list) {
        state.favorList = list
    },

    [types.CHANGE_MY_PACKAGE] (state, list) {
        state.packageList = list
    },

    [types.AJAX_UPDATE_FAVOR] (state, list) {
        state.favorList = state.favorList.concat(list)
    },

    [types.AJAX_DEL_FAVOR] (state, id) {
        for(let i in state.favorList) {
            if (state.favorList[i]['id'] == id) {
                state.favorList.splice(i , 1)
            }
        }
    },

    [types.AJAX_CHANGE_MOBILE] (state, mobile) {
        state.base.mobile = mobile
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/member.js